import { useCallback } from "react";

import { useSelector } from "react-redux";

import crmEnrichmentFiltersService from "../../services/filters";
import { selectJobState, selectMappings, selectWizardFilters } from "../../store/selectors";
import { CrmEnrichmentWizardSteps } from "../../types/types";
import { areMappingsValid } from "../../utils/mappingValidation";

const useStatefullWizardStepsValidation = () => {
    const currentJobState = useSelector(selectJobState);
    const wizardFilters = useSelector(selectWizardFilters);
    const mappings = useSelector(selectMappings);

    const isNextButtonDisabled = useCallback(
        (activeStepIndex: CrmEnrichmentWizardSteps): boolean => {
            switch (activeStepIndex) {
                case CrmEnrichmentWizardSteps.TypeStep:
                    return !currentJobState.jobType;
                case CrmEnrichmentWizardSteps.SettingsStep: {
                    const areCommonValuesInvalid = !currentJobState.jobObject || !currentJobState.enrichmentSource;

                    return currentJobState.jobType === "scheduled"
                        ? areCommonValuesInvalid || !currentJobState.refreshPeriod
                        : areCommonValuesInvalid;
                }
                case CrmEnrichmentWizardSteps.FiltersStep:
                    return (
                        wizardFilters.isApplyFiltersSelected === null ||
                        !crmEnrichmentFiltersService.areFiltersValid(wizardFilters)
                    );
                case CrmEnrichmentWizardSteps.FieldsMappingStep:
                    return !areMappingsValid(mappings);
                case CrmEnrichmentWizardSteps.ReviewStep: {
                    const areCommonValuesInvalid = !currentJobState.jobObject || !currentJobState.enrichmentSource;

                    return !!currentJobState.jobType && currentJobState.jobType === "scheduled"
                        ? areCommonValuesInvalid || !currentJobState.refreshPeriod
                        : areCommonValuesInvalid;
                }
                default:
                    return true;
            }
        },
        [currentJobState, wizardFilters, mappings],
    );

    const isAllPreviousStepsValid = useCallback(
        (index: number) => Array.from({ length: index }, (_, i) => i).every((i) => !isNextButtonDisabled(i)),
        [isNextButtonDisabled],
    );

    return {
        isNextButtonDisabled,
        isAllPreviousStepsValid,
    };
};

export default useStatefullWizardStepsValidation;
